export function OrderSummaryHeader() {
  return (
    <h2 className="text-xs font-medium mb-5 tracking-extra-wide uppercase">
      Order Summary
    </h2>
  );
}
